import ContentFeedService from './contentFeed.service';
import { HttpMethods } from '../enums/HttpMethods';
import { StatisticsData } from '../interfaces/StatisticsData';
import { EntityNames } from '../enums/EntityNames';

class StatisticsService {
  public static getEntityStatisticsByDateRange(start: string, end: string, entity: EntityNames): Promise<StatisticsData> {
    return ContentFeedService.sendRequest<void>(
      HttpMethods.GET,
      `${entity}/statistics/date-range?start=${start}&end=${end}`
    )
      .then((data) =>
        data
      )
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getTypesStatisticsByDateRange(start: string, end: string, content: 'contentPieces' | 'variations'): Promise<StatisticsData> {
    return ContentFeedService.sendRequest<void>(
      HttpMethods.GET,
      `types/statistics/date-range?start=${start}&end=${end}&content=${content}`
    )
      .then((data) =>
        data
      )
      .catch((error: Error) => {
        throw error;
      });
  }
}

export default StatisticsService;
